<seira-custom-error-page
	[statusCode]="404"
	msg="O recurso solicitado não foi encontrado."></seira-custom-error-page>
